import React, { useEffect, useState } from "react";
import axios from "axios";
import NavBar from "../../NavBar";
import Footer from "../../Footer";
import { useNavigate, useParams } from "react-router-dom";
import TipoPagoEmpresa from "./TipoPagoEmpresa";
import { useSelector } from "react-redux";
import Spinner from "../../Spinner";
import { loadStripe } from "@stripe/stripe-js";
import ModalLogeo from "../../alquilerScreen/alquilerAlojamiento/ModalLogeo";
import colores from "../../helpers/colores";
import ModalPolitica from "../casas/ModalPolitica";
import Swal from "sweetalert2";
import NavBarHome from "../../NavBarHome";

const CheckoutEmpresa = () => {
    const token = localStorage.getItem("token");
    const headers = {
        authorization: token,
    };
    const { idReserva, tipoPedido } = useParams();
    const [paying, setPaying] = useState(false);
    const [formaPago, setFormaPago] = useState("stripe");
    const [pedido, setPedido] = useState({});
    const navigate = useNavigate();
    const authUser = useSelector((state) => state.authReducer);
    const stripePromise = loadStripe(
        process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
    );
    const [comprobantePreview, setComprobantePreview] = useState(null);
    const [comprobante, setComprobante] = useState(null);
    const [habilitarModal, setHabilitarModal] = useState(false);
    const [modalLogeo, setModalLogeo] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const form = new FormData();

    const getReserva = async (idReserva) => {
        const { data } = await axios(
            `${process.env.REACT_APP_PROXY}/${
                tipoPedido === "embarcacion"
                    ? "pedidoEmbarcacion"
                    : "pedidoCasa"
            }/detalle/${idReserva}`,
            { headers }
        );

        setPedido({
            ...data,
            tipo_pedido: tipoPedido === "embarcacion" ? "Embarcacion" : "Casa",
        });
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        if (idReserva) getReserva(idReserva);
    }, [idReserva]);

    const handleComprobante = (e) => {
        if (!e.target.files || e.target.files.length === 0) {
            return;
        }
        setComprobante(e.target.files[0]);
        const objectUrl = URL.createObjectURL(e.target.files[0]);
        setComprobantePreview(objectUrl);
    };

    console.log(pedido);

    const handlePagoComprobante = async () => {
        setPaying(true);
        const costo = pedido.costo_asumido_empresa;
        const costo_tarjeta = 0;
        const metodo = "Transferencia bancaria";
        const file = comprobante;

        form.append("id", pedido.id);
        form.append("costo", costo);
        form.append("costo_tarjeta", costo_tarjeta);
        form.append("metodo", metodo);
        if (tipoPedido === "casa") {
            form.append("image_casa_pago", file);
        }
        if (tipoPedido === "embarcacion") {
            form.append("image_embarcacion_pago", file);
        }

        try {
            const { data } = await axios.post(
                `${process.env.REACT_APP_PROXY}/${
                    tipoPedido === "embarcacion"
                        ? "pedidoEmbarcacion"
                        : "pedidoCasa"
                }/realizarPagoTemporalEmpresa/`,
                form,
                { headers }
            );

            if (data.message === "Pago temporal de empresa guardado") {
                navigate(`/pago_aprobado/comprobante/${pedido.id}`);
            }
        } catch (error) {
            Swal.fire({
                title: error.response.data,
                icon: "error",
            });
            setPaying(false);
        }
    };

    if (pedido.id && pedido.pagado_empresa === "Si") {
        return (
            <div>
                <NavBarHome explorer={false} />
                <div
                    className={`${
                        authUser.tipo_usuario !== null &&
                        authUser.tipo_usuario <= 2
                            ? "pt-40"
                            : "pt-32"
                    } flex flex-col  select-none`}
                >
                    <div className={`bg-[${colores.primario}] text-center`}>
                        <h1 className="py-20 text-4xl font-bold text-white">
                            Checkout
                        </h1>
                    </div>
                    <div className="p-36">
                        <div className="p-10 text-xl border-8 border-dotted md:text-center md:text-3xl">
                            Este pago ya ha sido abonado por la empresa, muchas
                            gracias por su reserva.
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    } else if (pedido.id) {
        return (
            <div className="w-full flex flex-col">
                <NavBarHome explorer={false} />
                <div className="absolute w-full ">
                    {habilitarModal && (
                        <ModalLogeo
                            modalLogeo={modalLogeo}
                            setModalLogeo={setModalLogeo}
                        />
                    )}
                    {modalVisible && (
                        <ModalPolitica
                            setModalVisible={setModalVisible}
                            modalVisible={modalVisible}
                            politica={pedido?.cancelacion}
                            porcentaje={pedido?.porcentaje_moderado}
                        />
                    )}
                </div>
                {idReserva ? (
                    <div
                        className={`${
                            authUser.tipo_usuario !== null &&
                            authUser.tipo_usuario <= 2
                                ? "pt-40"
                                : "pt-32"
                        } flex flex-col select-none w-full`}
                    >
                        <div
                            className={`bg-[${colores.primario}] text-center w-full`}
                        >
                            <h1 className="py-20 w-full text-4xl font-bold text-white">
                                Checkout
                            </h1>
                        </div>
                        <div className="p-3 sm:mx-auto sm:p-10 lg:w-4/5">
                            {console.log(pedido)}
                            <div
                                className={`text-[${colores.primario}] font-semibold text-base flex flex-col-reverse`}
                            >
                                <TipoPagoEmpresa
                                    pedido={pedido}
                                    formaPago={formaPago}
                                    setFormaPago={setFormaPago}
                                    stripePromise={stripePromise}
                                    comprobantePreview={comprobantePreview}
                                    handleComprobante={handleComprobante}
                                    handlePagoComprobante={
                                        handlePagoComprobante
                                    }
                                    paying={paying}
                                />
                            </div>
                        </div>
                    </div>
                ) : (
                    <div
                        className={`${
                            authUser.tipo_usuario !== null &&
                            authUser.tipo_usuario <= 2
                                ? "pt-40"
                                : "pt-32"
                        } flex flex-col  select-none`}
                    >
                        <div className={`bg-[${colores.primario}] text-center`}>
                            <h1 className="py-20 text-4xl font-bold text-white">
                                Checkout
                            </h1>
                        </div>
                        <div className="p-36">
                            <div className="p-10 text-xl border-8 border-dotted md:text-center md:text-3xl">
                                No posee ninguna reserva pendiente
                            </div>
                        </div>
                    </div>
                )}
                <Footer />
            </div>
        );
    } else
        return (
            <div className="h-screen flex justify-center items-center">
                <Spinner width={12} />
            </div>
        );
};

export default CheckoutEmpresa;
